export const listTableCols = (tagMaterials, onTagNumberChange) => [
  {
    header: "#",
    accessorFn: (row, rowIndex) => (rowIndex === -1 ? "New" : rowIndex + 1),
    size: 5,
    enableSorting: false,
    enableEditing: false,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Edit: () => <></>,
  },
  {
    accessorKey: "tagNumber",
    header: "Tag#",
    size: 60,

    editVariant: "select",
    editSelectOptions: tagMaterials.map((d) => d.tagNumber),

    muiEditTextFieldProps: ({ row }) => ({
      select: true,
      onChange: (e) => {
        const selectedTag = e.target.value;

        const selectedItem = tagMaterials.find(
          (d) => d.tagNumber === selectedTag
        );

        // ✅ Update edit cache
        row._valuesCache.tagNumber = selectedTag;
        row._valuesCache.description = selectedItem?.description ?? "";
        row._valuesCache.mrqNumber = selectedItem?.mrqNumber ?? "";
        row._valuesCache.poNumber = selectedItem?.poNumber ?? "";
        row._valuesCache.selectedVendors = selectedItem?.selectedVendors ?? "";

        // ✅ Trigger parent component update
        if (onTagNumberChange) {
          onTagNumberChange(row.id, {
            ...selectedItem,
          });
        }

        console.log(row);
      },
    }),
  },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,
    grow: false,
    size: 160,
  },
  {
    accessorKey: "mrqNumber",
    header: "MRQ #",
    enableEditing: false,
    grow: false,
    size: 60,
  },
  // {
  //   accessorKey: "vendorList",
  //   header: "Vendor List",
  //   // enableEditing: false,
  //   grow: false,
  //   size: 60,
  // },
  {
    accessorKey: "poNumber",
    header: "PO #",
    enableEditing: false,
    grow: false,
    size: 60,
  },
  {
    accessorKey: "selectedVendors",
    header: "Selected Vendors",
    enableEditing: false,
    grow: false,
    size: 60,
  },
];
